import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useClerk } from "@clerk/clerk-react";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";

interface TermsModalProps {
  open: boolean;
}

export function TermsModal({ open }: TermsModalProps) {
  const { signOut } = useClerk();
  const acceptTerms = useMutation(api.data.acceptTerms);

  const handleAccept = async () => {
    await acceptTerms();
  };

  const handleDecline = () => {
    signOut();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Terms of Service</DialogTitle>
          <DialogDescription className="space-y-4 pt-4">
            <p>
              Welcome to our Beta software. Before proceeding, please read and
              accept our terms of service:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                This is Beta software powered by AI technology. While we strive for
                accuracy, the system may occasionally produce errors or unexpected
                results. We are not responsible for any data provided by the tooling. 
              </li>
              <li>
                You acknowledge that you are solely responsible for any content you
                submit to the platform.
              </li>
              <li>
                We reserve the right to review and analyze data submitted to the
                platform for service improvement, quality assurance,
                and any other purpose.
              </li>
              <li>
                The service is provided "as is" without warranties of any kind,
                either express or implied.
              </li>
            </ul>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button variant="destructive" onClick={handleDecline}>
            Decline
          </Button>
          <Button onClick={handleAccept}>Accept</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
} 